import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Button, WandIcon} from '@taopix/taopix-design-system';
import {useUserFlowState} from '../Context/UserFlow/UserFlowContext';
import {UserFlowType} from '../../Facade/UserFlow/UserFlowFacade';
import StartSmartDesignDialog from '../Dialogs/SmartDesign/StartSmartDesignDialog/StartSmartDesignDialog';
import {useExperience} from '../Experience/ExperienceProvider';
import {AIMode} from '@taopix/taopix-core';
import {useUiState} from '../Context/UserInterface/UserInterfaceContext';
import classNames from 'classnames';

type SmartDesignButtonProps = {
  toolPaletteOpen: boolean;
  onAutoFill: () => void;
};

const SmartDesignButton = ({toolPaletteOpen, onAutoFill}: SmartDesignButtonProps) => {
  const {t} = useTranslation();
  const {getAIMode} = useExperience();
  const userFlow = useUserFlowState();
  const aiMode = getAIMode();
  const ui = useUiState();
  const [startSmartDesignDialogOpen, setStartSmartDesignDialogOpen] = useState<boolean>(false);

  const onSmartDesign = () => {
    userFlow.resetStep();
    userFlow.activateUserFlow(UserFlowType.Assistant);
  };

  const smartDesignButtonClasses = classNames(
    'sm:fixed',
    'sm:mt-[-20rem]',
    'left-[10rem]',
    'z-10',
    'sm:shadow-[rgba(0,0,0,0.2)]',
    'sm:shadow-md'
  );

  return (
    <>
      <Button
        label={t('str_LabelSmartDesign')}
        buttonStyle="secondary"
        hideLabel={toolPaletteOpen || ui.state.isSmallScreen}
        size={ui.state.isSmallScreen ? 'large' : 'medium'}
        corners={ui.state.isSmallScreen ? 'round' : 'theme'}
        startIcon={<WandIcon />}
        id="smartdesignbutton"
        onClick={() => {
          if (AIMode.Off === aiMode) {
            setStartSmartDesignDialogOpen(true);
          } else if (AIMode.On === aiMode) {
            onSmartDesign();
          }
        }}
        aria-pressed={userFlow.isUserFlowActive(UserFlowType.Assistant)}
        className={smartDesignButtonClasses}
      />

      <StartSmartDesignDialog
        open={startSmartDesignDialogOpen}
        onAutoFill={onAutoFill}
        onStartSmartDesign={() => onSmartDesign()}
        onClose={() => setStartSmartDesignDialogOpen(false)}
      />
    </>
  );
};

export default SmartDesignButton;
